import React from "react";
import logo from "./logo.svg";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { Toaster } from "react-hot-toast";
import AnimatedCursor from "react-animated-cursor";

function App() {
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <AnimatedCursor
        innerSize={8}
        outerSize={20}
        color="36, 177, 179"
        outerAlpha={0.4}
        innerScale={0.6}
        outerScale={1.5}
        showSystemCursor={true}
      />

      <AppRoutes />
    </>
  );
}

export default App;
